(function () {
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var POSTED_KEY = 'newsletter-footer-posted';

  // The success message is no longer painted from JS: the server renders it in
  // sections/newsleter.liquid inside {% if form.posted_successfully? %}, when
  // Shopify sends the visitor back with ?customer_posted=true.

  // The submit is native because the store's CAPTCHA only protects that path
  // (over AJAX, /contact answers 400 "Missing CAPTCHA token" and nobody gets
  // saved). That forces a reload, and the browser starts at the very top: the
  // visitor ended up looking at the header without realising they had
  // subscribed, with the success message several screens down. Bring them back.
  function backToTheForm() {
    if (location.search.indexOf('customer_posted=true') === -1) return;

    // If the signup came from the modal, the modal handles it: it reopens in
    // its success state. Separate markers so the two never collide.
    var cameFromHere = false;
    try {
      cameFromHere = sessionStorage.getItem(POSTED_KEY) === '1';
      sessionStorage.removeItem(POSTED_KEY);
    } catch (err) {}
    if (!cameFromHere) return;

    var target = document.querySelector('.newsletter-form__success') ||
                 document.querySelector('.newsletter-section') ||
                 document.querySelector('.newsletter-form');
    if (!target) return;

    // 'instant' on purpose: with smooth the browser fights its own scroll
    // restoration and the jump looks worse than doing nothing.
    try { target.scrollIntoView({ block: 'center', behavior: 'instant' }); }
    catch (err) { target.scrollIntoView(); }

    // So a screen reader hears about it too, not only sighted visitors.
    var notice = target.querySelector('[role="status"]') || target;
    if (notice && notice.focus) {
      notice.setAttribute('tabindex', '-1');
      try { notice.focus({ preventScroll: true }); } catch (err) { notice.focus(); }
    }
  }

  function bindForm(form) {
    if (form.dataset.nlBound === '1') return;
    form.dataset.nlBound = '1';

    if (form.action) {
      try { form.action = form.action.split('#')[0]; } catch (err) {}
    }

    var input = form.querySelector('.newsletter-form__input');
    var button = form.querySelector('.newsletter-form__button');

    function showInlineError(msg) {
      var live = form.querySelector('.newsletter-form__live');
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      var p = document.createElement('p');
      p.className = 'newsletter-form__message newsletter-form__message--error newsletter-form__message--client';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      (live || form).appendChild(p);
    }

    function clearInlineError() {
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      if (input) input.setAttribute('aria-invalid', 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    // CAREFUL: this handler must NOT stop the submit when the email is valid.
    //
    // The store has Shopify's spam protection on, and the CAPTCHA hooks the
    // NATIVE submit event of the form generated by {% form %}. Sending the
    // email over fetch() bypasses it: /contact answers 400 with
    // {"errors":"Missing CAPTCHA token"} and the subscriber is never saved.
    // Worse: fetch's .then() still runs on a 400 (it only rejects on network
    // failure), so renderSuccess() was telling everyone "Thanks for
    // subscribing!" while nobody was being saved. Measured against AR
    // production on 2026-08-05 with this exact field set.
    //
    // The old stopImmediatePropagation() also killed Shopify's own CAPTCHA
    // listener, so there was no possible AJAX fix.
    //
    // Now we only validate: if the email is good, we let the native submit
    // through. Shopify adds the token, saves, and returns with
    // ?customer_posted=true; sections/newsleter.liquid paints the success with
    // form.posted_successfully?.
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('input[name="contact[website]"]');
      if (hp && hp.value) {
        e.preventDefault();
        return;
      }

      var value = input ? input.value.trim() : '';
      if (!EMAIL_RX.test(value)) {
        e.preventDefault();
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        showInlineError('Enter a valid email.');
        return;
      }

      clearInlineError();

      // Marks that the signup came from THIS form and not from the modal: both
      // return with ?customer_posted=true and we need to tell them apart to
      // know where to take the visitor after the reload.
      try { sessionStorage.setItem(POSTED_KEY, '1'); } catch (err) {}

      // Disable on the next tick: doing it inside the event itself makes some
      // browsers discard the button as the submitter and send nothing.
      if (button) {
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.textContent = 'Sending...';
        window.setTimeout(function () { button.disabled = true; }, 0);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.newsletter-form').forEach(bindForm);
  }

  init();
  backToTheForm();

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('.newsletter-form').forEach(function (f) {
      f.dataset.nlBound = '';
    });
    init(section);
  });
})();
